<template>
  <v-layout row wrap>
    <v-flex xs12 sm6 class="login-image hidden-sm-and-down">
      <img src="~@/assets/images/dashboard-bg.jpg" alt="">
    </v-flex>
    <v-layout justify-center align-center class="pa-3 sign-up">
      <router-link :to="{ name: 'signUp' }">{{$lang.labels.signUp}}</router-link>
    </v-layout>
    <v-layout justify-center align-center class="pa-4">
      <v-flex xs12 sm6>
        <h1 class="mb-4">{{$lang.global.projectName}}</h1>
        <v-alert color="error" class="err" :value="true" icon="warning" type="error" v-if="err">
          {{err}}
        </v-alert>
        <v-form>
          <v-flex xs12>
            <v-text-field
              color="primary"
              type="text"
              name="userName"
              v-model="formData.userName"
              :label="$lang.labels.username"
              required>
            </v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              color="primary"
              type="password"
              name="password"
              v-model="formData.password"
              :label="$lang.labels.password"
              required>
            </v-text-field>
          </v-flex>
          <v-flex xs12 text-xs-left>
            <v-btn :disabled="loginProcessStarted" color="primary" class="mx-0" type="submit" @click.prevent="submit">{{$lang.actions.submit}}</v-btn>
          </v-flex>
          <v-layout pt-3 px-1 v-if="version" class="justify-space-between">
            <span v-if="version.fe" class="info-text"><small>{{ $lang.labels.frontEndVersion }}: {{version.fe}}</small></span>
            <span v-if="version.be" class="info-text"><small>{{ $lang.labels.backendversion }}: {{version.be}}</small></span>
          </v-layout>
        </v-form>
      </v-flex>
    </v-layout>
  </v-layout>
</template>

<script>
  import Cookie from "vue-cookie";

  export default {
    data() {
      return {
        loginProcessStarted: false,
        formData: {
          userName: '',
          password: '',
        },
        err: '',
        fetchpaymentgatewaysDone: false,
        distanceunitsDone: false,
        timezonesDone: false,
        payments: [ 'cash', 'card', 'invoice', 'galaxycard', 'cheque', 'voucher', 'justeat',
          'hungryhouse', 'website', 'deliveroo', 'ubereats', 'amazon', 'cardmanual' ],
        languages: [],
        chargeTypes: [
          { value: 'chargespermile', text: this.$lang.labels.chargesPerMile },
          { value: 'nodeliverycharges', text: this.$lang.labels.noCharge },
          { value: 'chargesbymiles', text: this.$lang.labels.chargeByMile },
          { value: 'chargesbyinvoiceamount', text: this.$lang.labels.chargeByInvoice },
        ],
        serviceTypes: [
          { value: 'noservicecharge', text: this.$lang.labels.noService },
          { value: 'percoftotal', text: this.$lang.labels.percOfTotal },
        ],
        version: null,
      };
    },
    methods: {
      submit() {
        this.loginProcessStarted = true;
        this.err = '';
        // Check if Username/Password are empty
        if (this.formData.userName.length === 0) {
          this.err = this.$lang.errors.missingUsername;
          return;
        }
        if (this.formData.password.length === 0) {
          this.err = this.$lang.errors.missingPassword;
          return;
        }
        // Authenticate user
        this.$auth.login(this.formData)
          .then((err) => {
            if (err) {
              this.err = err;
              this.loginProcessStarted = false;
              return;
            }
            localStorage.removeItem("copyItemData");
            localStorage.removeItem("configUpdates");
            this.$http.get(`system/webshop/fetchpaymentgateways`)
              .then((res) => {
                this.fetchpaymentgatewaysDone = true;
                localStorage.setItem('paymentGateways', JSON.stringify(res.body.paymentGateways));
                localStorage.setItem('payments', JSON.stringify(this.payments));
                localStorage.setItem('chargeTypes', JSON.stringify(this.chargeTypes));
                localStorage.setItem('serviceTypes', JSON.stringify(this.serviceTypes));
                if (this.fetchpaymentgatewaysDone && this.distanceunitsDone && this.timezonesDone) {
                  this.loginProcessStarted = false;
                  this.$router.push({name: 'home'});
                }
              })
              .catch(err => {
                console.log(err);
                this.$auth.logout();
              });
            this.$http.get(`system/languages`)
              .then((res) => {
                const languages = res.body.languages;
                for (const lang in languages) {
                  this.languages.push({
                    text: this.$lang.labels[languages[lang]] || languages[lang],
                    value: languages[lang]
                  });
                }
                localStorage.setItem('languages', JSON.stringify(this.languages));
              })
              .catch(err => {
                console.log(err);
                this.$auth.logout();
                this.loginProcessStarted = false;
              });
            this.$http.get(`system/vatrates`)
              .then((res) => {
                const at = res.body.at.map(vat => Number(vat));
                const uk = res.body.uk.map(vat => Number(vat));
                const allowedVatRates = {
                  at,
                  uk,
                }
                localStorage.setItem('allowedVatRates', JSON.stringify(allowedVatRates));
              })
              .catch(err => {
                console.log(err);
                this.$auth.logout();
                this.loginProcessStarted = false;
              });
            this.$http.get(`system/distanceunits`)
              .then((res) => {
                this.distanceunitsDone = true;
                localStorage.setItem('distanceunits', JSON.stringify(res.body.distanceUnits));
                if (this.fetchpaymentgatewaysDone && this.distanceunitsDone && this.timezonesDone) {
                  this.loginProcessStarted = false;
                  this.$router.push({name: 'home'});
                }
              })
              .catch(err => {
                console.log(err);
                this.$auth.logout();
                this.loginProcessStarted = false;
              });
            this.$http.get(`system/timezones`)
              .then((res) => {
                this.timezonesDone = true;
                localStorage.setItem('timezones', JSON.stringify(res.body.timezones));
                if (this.fetchpaymentgatewaysDone && this.distanceunitsDone && this.timezonesDone) {
                  this.loginProcessStarted = false;
                  this.$router.push({name: 'home'});
                }
              })
              .catch(err => {
                console.log(err);
                this.$auth.logout();
                this.loginProcessStarted = false;
              });
          });
      },
      init() {
        return new Promise((resolve) => {
          Promise.all([
            this.$http.get('system/fetchversion')
              .then((res) => {
                if (res.body.status === 'Success') {
                  return res.body.version;
                }
                this.err = res.body.statusText;
              }, (err) => {
                this.companyLoading = false;
                this.err = err.body.statusText || err.body.message;
              }),
            this.$http.get('/static/version.txt')
              .then((res) => {
                if (res) {
                  return Number(res.body);
                }
                this.err = 'No FE version found!';
              }, () => {
                this.err = 'No FE version found!';
              }),
          ]).then((res) => resolve({be: res[0], fe: res[1]}));
        });
      },
    },
    created() {
      this.$auth.logout();
      this.init()
        .then((res) => {
          this.version = res;
        });
    }
  };
</script>

<style lang="scss" scoped>
  .row {
    height: 100%;
  }

  h1 {
    font-size: 2.5rem;
  }

  .login-image {
    position: relative;
    overflow: hidden;

    img {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: auto;
      min-width: 100%;
    }
  }

  @media only screen and (max-width: 600px) {
    h1 {
      font-size: 1.8rem;
    }
  }

  .sign-up {
    position: fixed;
    top: 0;
    right: 0;
  }
</style>



// WEBPACK FOOTER //
// LogIn.vue?7f574376